/**
 * Configuration options for cookie consent functionality.
 *
 * Defines default consent settings and cookie attributes for the consent system.
 * The domain is automatically determined using getTopCookieDomain().
 */
export const consentOptions: {
  defaultConsent: {
    necessary: boolean
    statistics: boolean
  }
  consentCookieAttributes: {
    expires: number
    path: string
    secure: boolean
    domain: string
    sameSite: string
  }
} = {
  defaultConsent: {
    necessary: false,
    statistics: false,
  },
  consentCookieAttributes: {
    expires: 365,
    path: '/',
    secure: process.env.NODE_ENV === 'production',
    domain: getTopCookieDomain(), // '.disco.ac',
    sameSite: 'Strict',
  },
}

/**
 * Determines the top-level domain for cookie setting.
 *
 * Extracts the top-level domain from the current hostname to ensure
 * cookies are set at the appropriate domain level. Uses a naive implementation
 * that works for standard domain formats.
 *
 * @returns The top-level domain prefixed with a dot (e.g., '.disco.ac')
 *
 * @example
 * ```typescript
 * // On 'app.disco.ac'
 * getTopCookieDomain() // returns '.disco.ac'
 *
 * // On 'localhost'
 * getTopCookieDomain() // returns '.localhost'
 * ```
 */
export function getTopCookieDomain(): string {
  if (typeof document === 'undefined') return ''

  // naive implementation for trivial cases like .com
  const host = document.location.hostname
  const parts = host.split('.')
  if (parts.length < 2) return '.' + host
  return '.' + parts.slice(parts.length - 2).join('.')
}
